import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';

import './stylesheets/index.css'

if (typeof URL.parse === 'undefined') {
  URL.parse = function (url, base) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

import App from './App';

Sentry.init({
  dsn: "https://ee61fab6ab8ed03a78ac110bf76e92e8@o4510139376009216.ingest.us.sentry.io/4510182310346752",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: `birmingham-frontend@${process.env.APP_VERSION ?? 'unknown'}`,
  environment: process.env.APP_ENV ?? 'production',
  traces_sample_rate: 1.0
});

const container = document.getElementById('root');

// Create a root.
const root = createRoot(container);
root.render(<App />);

// Deployment trigger: Thu Feb 19 02:10:21 CST 2026
